import React, { Fragment, useMemo, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { toggleGenericLoaderList } from '../Actions/GenericLoader.action';
import classNames from 'classnames';
import {
    maxFileSizeToDownload
} from '../constants';
const GenericLoader = () => {
    const dispatch = useDispatch();
    const [runningLoaderType, setRunningLoaderType] = useState('');
    const [isClosing, setIsClosing] = useState(false);
    const [loaderActive, setLoaderActive] = useState(false);
    const {
        loaderType,
        loaderState,
        loaderCounter,
        genericListLoaded,
        showGenericList,
        genericListItems,
        showText,
    } = useSelector((state) => state.genericLoader);

    const closeGenericLoaderList = () => {
        dispatch(toggleGenericLoaderList(false));
    };

    useEffect(() => {
        if (loaderCounter > 0) {
            setLoaderActive(true);
        }
        if (loaderCounter === 1) {
            setRunningLoaderType(loaderType);
        } else if (loaderCounter === 0) {
            setIsClosing(true);
            setTimeout(() => { setLoaderActive(false); setIsClosing(false); setRunningLoaderType(''); }, 0);
        }
    }, [loaderCounter]);
    const listItems = useMemo(() => (
        genericListItems?.map((item, index) => (
            <li key={`genericListItem${index}`} className={item.uploadStatus}>
                <span>{`${item.text} ${item.errorText || ''}`}</span>
            </li>
        ))
    ), [genericListItems]);

    return (
        <Fragment>
            {showGenericList && (
                <Fragment>
                    <div className="generic-loader__overlay"></div>
                    <div className="generic-loader__main-list">
                        <div className="generic-loader__close-btn" onClick={() => closeGenericLoaderList()}>
                            <span className="material-symbols-outlined">
                                cancel_presentation
                            </span>
                        </div>
                        <header>
                            <h4 className={`${!genericListLoaded ? 'active' : ''}`}>{translate('common.genericloader.uploading')} <span>{genericListItems?.length || 0}</span> {genericListItems?.length > 1 ? translate('common.genericloader.files') : translate('common.genericloader.file')}</h4>
                            <h5>{translate('common.genericloader.files.maxsizeis')}  {maxFileSizeToDownload / 1000000}MB</h5>
                        </header>
                        {genericListItems?.length > 0 &&
                            <div className="generic-loader__list-wrapper"><ol className="list">{listItems}</ol>
                                <div className={`${!genericListLoaded ? 'loading' : ''}`}>
                                    {genericListLoaded ?
                                        <Fragment>{translate('common.genericloader.files.filesareuploaded')}</Fragment> :
                                        <Fragment>{translate('common.genericloader.uploading')}</Fragment>
                                    }
                                </div>
                            </div>
                        }
                        <footer></footer>
                    </div>
                </Fragment>
            )}
            {loaderActive && (
                <div className={`generic-loader__wrapper ${isClosing ? 'closing' : ''}`}>
                    {loaderState !== 'timeOut' ? (
                        <div className={classNames('generic-loader', `generic-loader__${runningLoaderType}`, loaderState)}>
                            {runningLoaderType === 'ripple' && (
                                <div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            )}
                            {showText && <span className="loading-text">{translate('common.loadingtext')}</span>}
                        </div>) :
                        (
                            <div className="generic-loader">
                                {loaderState === 'timeOut' && <span className="timed-out">{translate('common.timeouttext')}</span>}
                            </div>
                        )}

                </div>
            )}
        </Fragment>
    );
};

export default GenericLoader;
